/* eslint-disable import/prefer-default-export */
import {
  INITIAL_DATA_GET_REQUEST,
  INITIAL_DATA_GET_SUCCESS,
  INITIAL_DATA_GET_ERROR,
} from 'Redux/types/initialDataTypes';

import { CALL_ACTIONS } from 'Redux/middleware';
import { BACKEND_URL_ACCOUNT } from 'Config/routes';


const fetchInitialData = () => (
  {
    [CALL_ACTIONS]: {
      TYPES: [INITIAL_DATA_GET_REQUEST, INITIAL_DATA_GET_SUCCESS, INITIAL_DATA_GET_ERROR],
      ENDPOINT: `${BACKEND_URL_ACCOUNT}initial_data/`,
      METHOD: 'GET',
    },
  });

export const loadInitialData = (data) => (dispatch) => dispatch(fetchInitialData(data));
